import React, { useState } from 'react'
import * as styles from './Footer.module.scss'
import { ReactSVG } from 'react-svg'
import classNames from 'classnames'

import { Button } from '../../molecules/button'

const FooterSocialLinks = ({ className }: { className: string }) => (
  <div className={`${styles.footerSocial} ${className}`}>
    <a href='https://facebook.com/flatfilers/'>Facebook</a>
    <a href='https://twitter.com/flatfile/'>X</a>
    <a href='https://linkedin.com/company/flatfile'>LinkedIn</a>
    <a href='https://github.com/FlatFilers'>Github</a>
    <a href='https://flatfile.com/join-slack/'>Dev Slack</a>
  </div>
)

const FooterCerts = () => (
  <div className={styles.footerCerts}>
    <img src='/img/certs/soc-2.svg' alt='SOC 2 badge' />
    <img src='/img/certs/gdpr.svg' alt='GDPR badge' />
    <img src='/img/certs/hipaa.svg' alt='HIPAA badge' />
  </div>
)

// data for footer navs
const footerNavs = [
  {
    title: 'Solutions',
    sectionName: 'solutions',
    links: [
      { text: 'For service teams', href: '/solutions/services/' },
      {
        text: 'For system integrators',
        href: '/solutions/system-integrators/'
      },
      { text: 'For NetSuite', href: '/editions/netsuite/' },
      { text: 'For Workday', href: '/editions/workday/' }
    ]
  },
  {
    title: 'Product',
    sectionName: 'product',
    links: [
      { text: 'Workbooks', href: '/product/workbooks/' },
      { text: 'Mapping', href: '/product/mapping/' },
      { text: 'Configuration', href: '/product/configuration/' },
      { text: 'Collaboration', href: '/product/collaboration/' },
      { text: 'Transform', href: '/product/transform/' },
      { text: 'Security', href: '/security/' }
    ]
  },
  {
    title: 'Resources',
    sectionName: 'resources',
    links: [
      {
        text: 'Blog',
        href: '/blog/'
      },
      {
        text: 'Customers',
        href: '/resources/case-studies/'
      },
      { text: "What's new in product", href: '/whats-new/' },
      { text: 'Reports & guides', href: '/resources/guides/' },
      { text: 'Events', href: '/resources/webinars/' },
      { text: 'Why Flatfile', href: '/why-flatfile/' },
      { text: 'What is Zero Trust AI?', href: '/resources/zero-trust-ai/' },
      { text: 'Knowledge base', href: 'https://support.flatfile.com/' }
    ]
  },
  {
    title: 'Company',
    sectionName: 'company',
    links: [
      {
        text: 'Pricing',
        href: '/pricing/'
      },
      {
        text: 'About',
        href: '/about/'
      },
      {
        text: 'News',
        href: '/news/'
      },
      {
        text: 'Careers',
        href: '/careers/',
        badgeText: "We're hiring!"
      },
      {
        text: 'Contact us',
        href: '/contact-us/'
      }
    ]
  },
  {
    title: 'For Developers',
    sectionName: 'forDevs1',
    links: [
      { text: 'Documentation', href: '/docs/overview/' },
      {
        text: 'API Reference',
        href: 'https://reference.flatfile.com/overview/welcome'
      },
      { text: 'API status', href: 'https://status.flatfile.io/' },
      {
        text: 'Developer office hours',
        href: '/resources/webinars/developer-office-hours/'
      },
      { text: 'Community', href: '/join-slack/' },
      { text: 'Support', href: '/docs/overview?action=showintercom' },
      { text: 'Changelog', href: '/docs/changelog/platform' }
    ]
  }
  // {
  //   title: 'Pricing',
  //   sectionName: 'pricing',
  //   links: [
  //     { text: 'Pricing plans', href: '/pricing/' },
  //     { text: 'Plan feature comparison', href: '/pricing/feature-comparison/' },
  //     { text: 'Pricing FAQ', href: '/pricing/faq/' }
  //   ]
  // },
  // {
  //   title: 'Get Started',
  //   sectionName: 'getStarted',
  //   links: [
  //     { text: 'Create a free Flatfile account', href: '/account/sign-up/' },
  //     { text: 'Get a demo', href: '/demo/' },
  //     { text: 'Log in', href: 'https://platform.flatfile.com/oauth/dashboard' }
  //   ]
  // }
]

const footerNavsDevelopers = [
  {
    title: 'For Developers',
    sectionName: 'forDevs2',
    links: [
      { text: 'Documentation', href: '/docs/overview/' },
      {
        text: 'API Reference',
        href: 'https://reference.flatfile.com/overview/welcome'
      },
      { text: 'API Status', href: 'https://status.flatfile.io/' },
      {
        text: 'Developer Office Hours',
        href: '/resources/webinars/developer-office-hours/'
      },
      { text: 'Community', href: '/join-slack/' },
      { text: 'Support', href: '/docs/overview?action=showintercom' },
      { text: 'Changelog', href: '/docs/changelog/platform' }
    ]
  }
]

const Footer = ({
  showCta = true,
  ctaBgColor = '#fff',
  ctaTitle = `<h3>Experience data projects <span>without the bottlenecks</span></h3>`,
  ctaBtnText = 'Book a demo',
  ctaBtnPath = '/demo/',
  variant = 'primary',
  hideFooterMain = false
}: {
  showCta?: boolean
  ctaBgColor?: string
  ctaTitle?: string
  ctaBtnText?: string
  ctaBtnPath?: string
  variant?: 'primary' | 'secondary'
  hideFooterMain?: boolean
}) => {
  const currentYear = new Date().getFullYear()
  const [activeSection, setActiveSection] = useState<string | null>(null)

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section)
  }

  return (
    <>
      {showCta && (
        <div className={styles.ctaBar}>
          <div className={styles.ctaBarContent}>
            <div className={styles.ctaBarContentInnerWrapper}>
              <div className={styles.ctaBarContentInner}>
                <div dangerouslySetInnerHTML={{ __html: ctaTitle }} />

                {ctaBtnText && (
                  <Button
                    variant='primary'
                    size='large'
                    showTrailIcon={true}
                    className={styles.footerCtaButton}
                    href={ctaBtnPath}
                  >
                    {ctaBtnText}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* if footer variant is secondary, add className={styles.secondary} */}
      <footer
        className={
          styles.footer +
          (variant === 'secondary' ? ' ' + styles.secondary : '')
        }
      >
        <div
          className={`${styles.footerContainer} ${
            showCta ? '' : styles.footerNoCta
          }`}
        >
          <div
            className={classNames(styles.footerLogo, {
              [styles.hide]: hideFooterMain
            })}
          >
            <img src='/img/logos/flatfile_white.svg' width={127} />
            <ReactSVG src='/assets/logos/security/security-badges-footer.svg' />
          </div>
          <div
            className={classNames(styles.footerMain, {
              [styles.hide]: hideFooterMain
            })}
          >
            <div className={styles.footerNavlinks}>
              {footerNavs.map(nav => (
                // add a unique className to each section
                <div
                  key={nav.sectionName}
                  className={`${styles.footerSection} ${
                    styles[nav.sectionName]
                  }`}
                >
                  <h4 onClick={() => toggleSection(nav.sectionName)}>
                    {nav.title}
                    <ReactSVG
                      src='/img/icons/chevron-down-small.svg'
                      className={`${styles.arrow} ${
                        activeSection === nav.sectionName ? styles.open : ''
                      }`}
                    />
                  </h4>
                  <ul
                    className={
                      activeSection === nav.sectionName ? styles.active : ''
                    }
                  >
                    {nav.links.map(link => (
                      <li key={link.text}>
                        <a href={link.href}>
                          {link.text}
                          {link.badgeText && <span>{link.badgeText}</span>}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className={styles.footerNavlinksDevelopers}>
              {footerNavsDevelopers.map(nav => (
                <div
                  key={nav.sectionName}
                  className={`${styles.footerSection} ${
                    styles[nav.sectionName]
                  }`}
                >
                  <h4 onClick={() => toggleSection(nav.sectionName)}>
                    {nav.title}
                    <ReactSVG
                      src='/img/icons/chevron-down-small.svg'
                      className={`${styles.arrow} ${
                        activeSection === nav.sectionName ? styles.open : ''
                      }`}
                    />
                  </h4>
                  <ul
                    className={
                      activeSection === nav.sectionName ? styles.active : ''
                    }
                  >
                    {nav.links.map(link => (
                      <li key={link.text}>
                        <a href={link.href}>
                          {link.text}
                          {link.badgeText && <span>{link.badgeText}</span>}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className={styles.mobileSocialCerts}>
              <FooterSocialLinks className={styles.mobile} />
            </div>
          </div>

          <div
            className={classNames(styles.footerMeta, {
              [styles.removePadding]: hideFooterMain
            })}
          >
            <div className={styles.footerLegal}>
              <p>&copy; {currentYear} Flatfile</p>
              <a href='/privacy/'>Privacy Policy</a>
              <a href='/terms/'>Terms of Use</a>

              {/* Needs to exist for iubenda to not place the ugly white bar at bottom of site */}
              <a
                href='javascript:void(0);'
                className='iubenda-cs-uspr-link visually-hidden'
              >
                Notice at Collection
              </a>

              <a
                href='javascript:void(0);'
                className={`iubenda-cs-preferences-link ${styles.preferencesLink}`}
              >
                <img
                  src="data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 14' style='enable-background:new 0 0 30 14;' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill-rule:evenodd;clip-rule:evenodd;fill:%23FFFFFF;%7d .st1%7bfill-rule:evenodd;clip-rule:evenodd;fill:%230066FF;%7d .st2%7bfill:%23FFFFFF;%7d .st3%7bfill:%230066FF;%7d %3c/style%3e%3cg%3e%3cg id='final---dec.11-2020_1_'%3e%3cg id='_x30_208-our-toggle_2_' transform='translate(-1275.000000, -200.000000)'%3e%3cg id='Final-Copy-2_2_' transform='translate(1275.000000, 200.000000)'%3e%3cpath class='st0' d='M7.4,12.8h6.8l3.1-11.6H7.4C4.2,1.2,1.6,3.8,1.6,7S4.2,12.8,7.4,12.8z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg id='final---dec.11-2020'%3e%3cg id='_x30_208-our-toggle' transform='translate(-1275.000000, -200.000000)'%3e%3cg id='Final-Copy-2' transform='translate(1275.000000, 200.000000)'%3e%3cpath class='st1' d='M22.6,0H7.4c-3.9,0-7,3.1-7,7s3.1,7,7,7h15.2c3.9,0,7-3.1,7-7S26.4,0,22.6,0z M1.6,7c0-3.2,2.6-5.8,5.8-5.8 h9.9l-3.1,11.6H7.4C4.2,12.8,1.6,10.2,1.6,7z'/%3e%3cpath id='x' class='st2' d='M24.6,4c0.2,0.2,0.2,0.6,0,0.8l0,0L22.5,7l2.2,2.2c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0 l0,0l-2.2-2.2L19.5,10c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l0,0L20.8,7l-2.2-2.2c-0.2-0.2-0.2-0.6,0-0.8 c0.2-0.2,0.6-0.2,0.8,0l0,0l2.2,2.2L23.8,4C24,3.8,24.4,3.8,24.6,4z'/%3e%3cpath id='y' class='st3' d='M12.7,4.1c0.2,0.2,0.3,0.6,0.1,0.8l0,0L8.6,9.8C8.5,9.9,8.4,10,8.3,10c-0.2,0.1-0.5,0.1-0.7-0.1l0,0 L5.4,7.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l0,0L8,8.6l3.8-4.5C12,3.9,12.4,3.9,12.7,4.1z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"
                  alt='California Consumer Privacy Act (CCPA) Opt-Out Icon'
                />
                Your Privacy Choices
              </a>
            </div>
            <FooterSocialLinks className={styles.desktop} />
          </div>
        </div>
      </footer>
    </>
  )
}
export default Footer
